<template>
  <div class="page">
    <!-- 头部 -->
    <YorkbbsHeader>
      <el-breadcrumb-item to="/">
        <span>约克黄页</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>发布黄页</el-breadcrumb-item>
    </YorkbbsHeader>

    <div class="page-wrapper">
      <el-form class="page-left" label-width="110px" label-position="left" size="medium">
        <!-- 基本信息 -->
        <div class="form-section">
          <div class="form-header">
            <strong class="form-header__name">商家信息</strong>
            <span class="form-header__required">* 必填项</span>
          </div>
          <!-- 所属类别 -->
          <el-form-item label="所属类别" required v-if="topics.length">
            <el-select
              class="form-width__270"
              v-model="topicId"
              clearable
              placeholder="请选择和输入类别"
              filterable
              @change="onTopicSelected"
            >
              <el-option-group v-for="sup in topics" :key="sup.id" :label="sup.name">
                <el-option v-for="sub in sup.children" :key="sub.id" :label="sub.name" :value="sub.id"> </el-option>
              </el-option-group>
            </el-select>
            <div class="form-item__tip">输入时，自动匹配类别</div>
          </el-form-item>
          <!-- 信息标题 -->
          <el-form-item label="信息标题" required>
            <el-input
              class="form-width__500"
              v-model="form.title"
              clearable
              placeholder="请输入信息标题"
              maxlength="50"
              show-word-limit
            ></el-input>
          </el-form-item>
          <!-- 商家简介 -->
          <el-form-item label="商家简介" required>
            <YorkbbsEditor
              ref="editor"
              placeholder="请输入商家简介，增加曝光率"
              @change="onEditorChange"
            ></YorkbbsEditor>
          </el-form-item>
        </div>

        <!-- 联系信息 -->
        <div class="form-section">
          <div class="form-header">
            <strong class="form-header__">联系信息</strong>
          </div>
          <!-- 联系人 -->
          <el-form-item label="联系人" required>
            <el-input class="form-width__270" v-model="form.contactName" clearable placeholder=""></el-input>
          </el-form-item>
          <!-- 联系电话 -->
          <el-form-item label="联系电话" required>
            <YorkbbsPhoneInput
              class="form-width__270"
              v-model="form.contactNumber"
              clearable
              numeric
              placeholder=""
            ></YorkbbsPhoneInput>
          </el-form-item>
          <!-- 邮箱 -->
          <el-form-item label="Email" required>
            <el-input class="form-width__270" v-model.trim="form.email" clearable placeholder=""></el-input>
          </el-form-item>
          <!-- 网址 -->
          <el-form-item label="网址">
            <el-input class="form-width__270" v-model.trim="form.website" clearable placeholder=""></el-input>
          </el-form-item>
          <!-- 微信号 -->
          <el-form-item label="微信号">
            <el-input class="form-width__270" v-model="form.weChatId" clearable placeholder=""></el-input>
          </el-form-item>
          <!-- 微信二维码 -->
          <el-form-item label="微信二维码">
            <YorkbbsUploadQrcode :url.sync="form.weChatQrcode"></YorkbbsUploadQrcode>
          </el-form-item>
        </div>

        <!-- 所在位置 -->
        <div class="form-section">
          <div class="form-header">
            <strong class="form-header__name">商家名/位置</strong>
          </div>
          <!-- 商家名称 -->
          <el-form-item label="中文名称">
            <el-input class="form-width__270" v-model="form.shopCnName" clearable placeholder=""></el-input>
            <div class="form-item__tip">中文名称，例：春夏秋冬私房菜</div>
          </el-form-item>
          <!-- 商家英文名称 -->
          <el-form-item label="英文名称">
            <el-input class="form-width__270" v-model="form.shopEnName" clearable placeholder=""></el-input>
            <div class="form-item__tip">英文名称，例：Roasted Duck</div>
          </el-form-item>
          <!-- 地址 -->
          <el-form-item label="商家地址">
            <YorkbbsAddress
              :detailVisible="form.showMyDetailAddress"
              :latitude="form.latitude"
              :longitude="form.longitude"
              :address="form.address"
              :city="form.cityId"
              @change="onAddressChange"
            >
              <div slot="tip"></div>
            </YorkbbsAddress>
          </el-form-item>
        </div>
        <div class="form-submit">
          <el-button class="form-button__submit" type="primary" :loading="submitLoading" @click="savePost">
            发布
          </el-button>
        </div>
      </el-form>
      <div class="page-right">
        <!-- 帮助信息 -->
        <YorkbbsService :noticeVisible="true" :questionList="questionList"></YorkbbsService>
      </div>
    </div>

    <!-- 底部 -->
    <YorkbbsFooter></YorkbbsFooter>

    <YorkbbsUnauthDialog :visible.sync="unauthVisible"></YorkbbsUnauthDialog>
  </div>
</template>
<script>
import { hostBuild } from '@/utils/utils';
import { regexEmail } from '@/common/account/utils/regex';
import YorkbbsHeader from '@/common/header/header-simple.vue';
import YorkbbsEditor from '@/common/editor/full-editor.vue';
import YorkbbsUploadQrcode from '@/common/form-upload/form-upload-qrcode.vue';
import YorkbbsAddress from '@/common/form-address/form-address.vue';
import YorkbbsService from '@/common/card-server.vue';
import YorkbbsFooter from '@/common/footer/footer-simple.vue';
import YorkbbsPhoneInput from '@/common/input-phone.vue';
import YorkbbsUnauthDialog from '@/common/account/auth/dialog-unauth.vue';

export default {
  name: 'Publish',
  components: {
    YorkbbsHeader,
    YorkbbsEditor,
    YorkbbsUploadQrcode,
    YorkbbsAddress,
    YorkbbsService,
    YorkbbsFooter,
    YorkbbsPhoneInput,
    YorkbbsUnauthDialog,
  },
  data() {
    return {
      form: {
        topics: [], // 所属类别
        title: '', // 信息标题
        content: '', // 商家简介
        imageList: [], // 编辑器内图片
        shopCnName: undefined, // 商家名称
        shopEnName: undefined, // 商家英文名称
        contactName: undefined, // 联系人
        contactNumber: undefined, // 联系电话
        email: undefined, // 邮箱
        website: undefined, // 网址
        weChatId: undefined, // 微信号
        weChatQrcode: undefined, // 微信二维码
        address: undefined, // 地址
        cityId: undefined, // 城市ID
        showMyDetailAddress: 0, // 是否显示详细地址
        longitude: undefined, // 经度
        latitude: undefined, // 纬度
      },

      // 板块列表
      topics: [],
      // 选中的板块
      topicId: '',

      // 编辑器对象
      editor: null,

      // 发布加载状态
      submitLoading: false,
      // 黄页信息加载状态
      loading: false,

      // 问题列表
      questionList: [
        {
          title: '如何发布黄页信息？',
          host: 'forum',
          path: '/detail/ff8d1adf-e6e0-473f-ab09-26e554ff9c5e?topic=manage&offset=1#2',
        },
        {
          title: '如果没有找到需要的类别？',
          host: 'forum',
          path: '/detail/ff8d1adf-e6e0-473f-ab09-26e554ff9c5e?topic=manage&offset=1#3',
        },
        {
          title: '如何修改/删除黄页信息？',
          host: 'forum',
          path: '/detail/ff8d1adf-e6e0-473f-ab09-26e554ff9c5e?topic=manage&offset=1#4',
        },
        {
          title: '如何推广黄页信息？',
          host: 'forum',
          path: '/detail/ff8d1adf-e6e0-473f-ab09-26e554ff9c5e?topic=manage&offset=1#5',
        },
      ],

      unauthVisible: false,
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
  },
  watch: {
    user: {
      immediate: true,
      handler() {
        // 用户数据加载完成
        if (this.$store.getters.userLoading) return;

        if (!this.user.id) {
          location.replace(hostBuild('/login?redirect=' + hostBuild(this.$route.fullPath, 'house'), 'account'));
          return;
        }

        this.form.email = this.user.email;
        this.form.contactNumber = this.user.phone;
        if( !this.$route.query.id ){
          if (this.user.phoneAuth == 0 || this.user.phonePrefix != '+1') {
            this.unauthVisible = true;
            return;
          }
        }

        if (this.user.status == 2 || this.user.status == 3) {
          const text = this.user.status == 2 ? '禁言' : '封杀';
          this.$alert(`您已经被${text}，不能进行发布和修改操作！`, '提示', {
            confirmButtonText: '确定',
            type: 'warning',
            showClose: false,
            callback: () => {
              this.$router.replace('/');
            },
          });
        }
      },
    },
  },
  created() {
    if (this.$route.query.id) this.getPost();
    this.getTopics();
  },
  methods: {
    /**
     * 获取黄页信息
     */
    async getPost() {
      this.loading = true;
      const { data } = await this.$axios
        .post('/info/v1/get/post/detail', { postId: this.$route.query.id })
        .finally(() => {
          this.loading = false;
        });

      // 基本信息
      this.topicKeyword = data.property.topics[0].name;
      this.form.topics = data.property.topics.map(item => item.id);
      this.topicId = this.form.topics[0];
      this.form.title = data.title;
      this.$refs.editor.html(data.content);

      // 联系信息
      this.form.shopCnName = data.property.shopCnName;
      this.form.shopEnName = data.property.shopEnName;
      this.form.contactName = data.property.contactName;
      this.form.contactNumber = data.property.contactNumber;
      this.form.email = data.property.email;
      this.form.website = data.property.website;
      this.form.weChatId = data.property.weChatId;
      this.form.weChatQrcode = data.property.weChatQrcode;

      // 所在位置
      this.form.address = data.property.address;
      this.form.cityId = data.property.cityId;
      this.form.showMyDetailAddress = data.property.showMyDetailAddress;
      this.form.longitude = data.location.lon;
      this.form.latitude = data.location.lat;
    },
    abcHostToCanada(htmlStr){
      let reg =/media\d\.abc123\.life\/media/g;
      return htmlStr.replace(reg,'media.canada-cn.net/media')
    },
    /**
     * 新增/修改黄页
     */
    async savePost() {
      // d3bfcc4f-7ba4-4d2a-a9d9-fd4e8a74fd5c
      if (!this.form.topics.length) return this.$warning('请选择所属类别');
      if (!this.form.title.length) return this.$warning('请输入信息标题');
      if (!this.form.content.length) return this.$warning('请输入商家简介');
      if (!this.form.contactName) return this.$warning('请输入联系人');
      if (!/^\d{9,11}$/.test(this.form.contactNumber)) return this.$warning('联系电话格式不正确');
      if (!regexEmail.test(this.form.email)) return this.$warning('邮箱格式不正确');

      const url = this.$route.query.id ? '/info/v1/update/post' : '/info/v1/create/post';

      this.submitLoading = true;
      let sendData = {
        postId: this.$route.query.id,
        ...this.form,
        claim: 1, // 默认认领状态
      }
      sendData.content = this.abcHostToCanada(sendData.content);
      sendData.imageList = sendData.imageList.map(item=>{
        return this.abcHostToCanada(item);
      });
      const { data } = await this.$axios
        .post(url, sendData)
        .finally(() => {
          this.submitLoading = false;
        });

      if (this.$route.query.id) {
        this.$success('修改成功');
        this.$router.replace(`/success/${this.$route.query.id}`);
      } else {
        this.$success('发布成功');
        this.$router.replace(`/success/${data.id}`);
      }
    },

    /**
     * 获取板块列表
     */
    async getTopics() {
      const { data } = await this.$axios.post('/info/v1/get/topic/tree', {
        status: [0],
        topicType: [1],
      });
      this.topics = data.topic;
    },
    /**
     * 选中板块时
     */
    onTopicSelected(id) {
      this.form.topics = [id];
    },
    /**
     * 地址发生变化
     */
    onAddressChange({ address, cityId, latitude, longitude, showMyDetailAddress }) {
      this.form.address = address;
      this.form.cityId = cityId;
      this.form.latitude = latitude;
      this.form.longitude = longitude;
      this.form.showMyDetailAddress = showMyDetailAddress;
    },
    /**
     * 编辑器内容发生变化
     */
    onEditorChange({ html, text, images }) {
      this.form.content = html;
      this.form.imageList = images;
    },
  },
};
</script>
<style lang="scss" scoped>
.page {
  min-height: 100vh;
  background-color: #f8f8f8;
}
.page-wrapper {
  width: 1170px;
  margin: auto;
  padding-top: 30px;
  padding-bottom: 100px;
  display: flex;
  justify-content: space-between;
}
.page-left {
  width: 830px;
  box-sizing: border-box;
  padding: 30px 30px 60px;
  background: #ffffff;
  border-radius: 6px;
}
.page-right {
  width: 300px;
}

.form-section {
  margin-bottom: 50px;
}
.form-header {
  margin-bottom: 30px;
  font-size: 18px;
  line-height: 25px;
}
.form-header__required {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: var(--primary-color);
  margin-left: 10px;
}
.form-header__tip {
  font-size: 14px;
  line-height: 17px;
  color: var(--text-color-9);
  margin-left: 30px;
}
.form-item__tip {
  font-size: 14px;
  line-height: 20px;
  color: var(--text-color-9);
  margin-top: 8px;
}

.form-width__270 {
  width: 270px;
}
.form-width__400 {
  width: 400px;
}
.form-width__500 {
  width: 500px;
}

.form-submit {
  text-align: center;
}

.form-button__submit {
  width: 300px;
  height: 50px;
  font-size: 20px;
}
</style>
<style lang="scss">
.el-select-group__wrap {
  .el-select-group {
    li {
      padding-left: 40px;
    }
  }
}
</style>
